module.exports = __webpack_public_path__ + "static/media/p2s1.933afff2.jpg";